var module = angular.module('octopusApp.infrastructure');

// Make these Octopus.Client services available as Angular services

module.factory('octopusClient', function ($q, $rootScope) {
    Octopus.Client.PromiseWrapper = function(callback) {
        var deferred = $q.defer();

        callback(function ResolvePromise(value) {
            if ($rootScope.$$phase) {
                deferred.resolve(value);
            } else {
                $rootScope.$apply(function () {
                    deferred.resolve(value);
                });
            }
        }, function RejectPromise(value) {
            if ($rootScope.$$phase) {
                deferred.reject(value);
            } else {
                $rootScope.$apply(function () {
                    deferred.reject(value);
                });
            }
        });

        return deferred.promise;
    };
    return Octopus.App.Client;
});

module.factory('octopusRepository', function (octopusClient) {
    return new Octopus.Client.Repository(octopusClient);
});

module.factory('octopusPermissionSet', function(octopusRepository, $q) {

    var ps = {};

    var refresh = function() {
        ps = {};
        _.each(Octopus.App.currentPermissionSet, function(v, k) {
            ps[k.toLowerCase()] = jQuery.map(v, function(e) {
                return { 
                    projectIds: jQuery.map(e.RestrictedToProjectIds || [], function(id) { return id.toLowerCase(); }),
                    environmentIds: jQuery.map(e.RestrictedToEnvironmentIds || [], function(id) { return id.toLowerCase(); }),
                    projectGroupIds: jQuery.map(e.RestrictedToProjectGroupIds || [], function(id) { return id.toLowerCase(); }) 
                };
            });
        });
    };

    refresh();

    return {
        refresh: refresh,

        firstAuthorized: function (permissions) {
            var result = $q.defer();

            var evaluate = function() {
                var match = null;

                _.each(permissions, function (p) {
                    var restrictions = ps[p.toLowerCase()];

                    if (!restrictions) {
                        return;
                    }

                    if (!match) {
                        match = p;
                    }
                });

                return match;
            };

            result.resolve(evaluate());

            return result.promise;
        },

        isAuthorized: function(authorization) {

            var result = $q.defer();

            var isWildcard = function(s) {
                return s === '*';
            };

            var evaluate = function() {
                var restrictions = ps[authorization.permission.toLowerCase()];

                if (!restrictions) {
                    // User doesn't have the permission in any scope
                    return false;
                }

                if (restrictions.length === 0) {
                    // No restrictions
                    return true;
                }

                for (var i = 0; i < restrictions.length; i++) {
                    var restriction = restrictions[i];
                    var allowed = true;

                    if (restriction.projectIds.length !== 0) {
                        if (authorization.projectId == null ||
                            (!isWildcard(authorization.projectId) &&
                             jQuery.inArray(authorization.projectId.toLowerCase(), restriction.projectIds) === -1)) {
                            allowed = false;
                        }
                    }

                    if (restriction.environmentIds.length !== 0) {
                        if (authorization.environmentId == null ||
                            (!isWildcard(authorization.environmentId) &&
                             jQuery.inArray(authorization.environmentId.toLowerCase(), restriction.environmentIds) === -1)) {
                            allowed = false;
                        }
                    }

                    if (restriction.projectGroupIds.length !== 0) {
                        if (authorization.projectGroupId == null ||
                            (!isWildcard(authorization.projectGroupId) &&
                             jQuery.inArray(authorization.projectGroupId.toLowerCase(), restriction.projectGroupIds) === -1)) {
                            allowed = false;
                        }
                    }

                    if (allowed) {
                        return true;
                    }
                }
                return false;
            };

            result.resolve(evaluate());

            return result.promise;
        }
    };
});


module.factory('octopusFeatures', function($q, octopusRepository) {
    var currentFeatures = {};

    function refresh() {
        return octopusRepository.FeaturesConfiguration.get().then(function (features) {
            currentFeatures = features;
        });
    }

    function isEnabled(feature){
        return !!currentFeatures[feature];
    }

    function clear(){
        currentFeatures = {};
    }

    refresh();
    return {
        refresh: refresh,
        isEnabled: isEnabled,
        clear: clear
    };
});

module.factory('octopusTagSets', function ($q, octopusRepository) {
    var tagSeperator = "/";
    var tagLoader = null;

    function getAll() {
        return tagLoader = octopusRepository.TagSets ?
            octopusRepository.TagSets.all() :
            $q.resolve([]);
    }

    function getTag(canonicalTagName) {
        if (typeof canonicalTagName === 'string') {
            return getTagSingle(canonicalTagName);
        } else if (_.isArray(canonicalTagName)) {
            return getTagArray(canonicalTagName);
        }
    }

    function getTagSingle(canonicalTagName) {
        return tagLoader.then(function (tagSets) {
            var tag = findSingleTag(canonicalTagName, tagSets);
            if (!!tag) {
                return tag;
            }

            //Tag didn't match any in collection... lets try load and find again.
            return getAll().then(function (tagSets) {
                return findSingleTag(canonicalTagName, tagSets);
            });
        });
    }

    function getTagArray(canonicalTagNames) {
        return tagLoader.then(function(tagSets) {
            var mapped = canonicalTagNames.map(function(t){ return findSingleTag(t, tagSets); });
            if (mapped.indexOf(null) === -1){
                return mapped;
            }

            //There was a tag missing in the collection... lets try load and find again.
            return getAll().then(function(tagSets){
                return canonicalTagNames.map(function(t){ return findSingleTag(t, tagSets); });
            });
        });
    }

    function findSingleTag(canonicalTagName, tagSets) {
        var tagSetName = canonicalTagName.split(tagSeperator)[0];
        for (var i in tagSets) {
            var tagSet = tagSets[i];
            if (tagSet.Name !== tagSetName) {
                continue;
            }

            for (var j in tagSet.Tags) {
                var tag = tagSet.Tags[j];
                if (canonicalTagName === tag.CanonicalTagName) {
                    return tag;
                }
            }
        }
        return null;
    }

    function groupByTagSet(canonicalTagNames) {
        return _.groupBy(canonicalTagNames, function(ctn) { return ctn.split(tagSeperator)[0]; } );
    }

    getAll();
    return {
        getAll: getAll,
        getTag: getTag,
        groupByTagSet: groupByTagSet
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octopus_client.js
// module id = 3784174953249734
// module chunks = 1